import { create } from 'zustand'

const useProdCreationStore = create((set) => ({
  products: [],
  total: 0,
  page: 1,
  totalPages: 1,
  fetchProdCreation: async (page = 1, limit = 10) => {
    try {
      const response = await fetch(`/api/extensive-prod-creation-requests/getBatches?page=${page}&limit=${limit}`);
      if (!response.ok) {
        throw new Error('Failed to fetch departments');
      }
      const data = await response.json();
      set({
        products: data.data,
        total: data.total,
        page: data.page,
        totalPages: data.totalPages
      });
    } catch (error) {
      console.error('Error fetching product creation:', error);
      set({ products: [], total: 0, page: 1, totalPages: 1 });
    }
  },
}));

export default useProdCreationStore